import { render, staticRenderFns } from "./NoRefundYet.vue?vue&type=template&id=19265cd0&scoped=true"
import script from "./NoRefundYet.vue?vue&type=script&lang=js"
export * from "./NoRefundYet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19265cd0",
  null
  
)

export default component.exports